module.exports = __webpack_public_path__ + "static/media/cover12.968d1c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover12.png
// module id = 565
// module chunks = 0